import { CLOSE_TOAST, OPEN_AND_SET_TOAST_CONTENT } from "../constants";
import { CSSProperties, ReactNode } from "react";

export const closeToast = () => ({ type: CLOSE_TOAST });

export const openToastAndSetContent = ({
	toastContent,
	toastStyles,
	toastType,
}: {
	toastContent: ReactNode;
	toastStyles?: CSSProperties;
	toastType?: "success" | "error";
}) => {
	return {
		type: OPEN_AND_SET_TOAST_CONTENT,
		toastContent,
		toastStyles,
		toastType,
	};
};
